import { Stands } from '../Stands';
import { AppConfigs } from './AppConfigs/AppConfigs';
import { daData } from './commonApis';

export const services = {
	showcase: 'showcase',
	daData: 'daData',
	clientAuthApi: 'clientAuthApi',
	clientAppFormApi: 'clientAppFormApi',
};

const showcase = {
	[Stands.test]: 'https://showcase.efrtest.ru/api',
	[Stands.cert]: 'https://showcase.efrcert.ru/api',
	[Stands.prod]: 'https://showcase.efr.ru/api',
};

const gateway = {
	[Stands.test]: 'https://api.efrtest.ru',
	[Stands.cert]: 'https://api.efrcert.ru',
	[Stands.prod]: 'https://api.efr.ru',
};

const daDataKeys = {
	[Stands.test]: '7d85413b16caef9e486a1349ec83a16955b71828',
	[Stands.cert]: '7d85413b16caef9e486a1349ec83a16955b71828',
	[Stands.prod]: '7d85413b16caef9e486a1349ec83a16955b71828',
};
export const efrBotPaths = ['/'];

export const appEfrConfig = new AppConfigs<typeof services>({
	servicesHosts: {
		showcase,
		clientAppFormApi: gateway,
		clientAuthApi: gateway,
		daData,
	},
	daDataKeys,
	appHostName: 'efr',
	captchaPublicKey: 'ysc1_wQ5AuwMP2VjQS6H1DANGXKk5DFjIuYgAlDYnb7nz2089a78a',
	publicPath: '/',
	serviceWorkerVersion: '0.0.6',
});
export type AppEfrConfig = AppConfigs<typeof services>;
